import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HomeTransactionsComponent } from 'app/home';
import { ExportFileTypeModel } from 'app/models';

@Component({
    selector: 'export-operators',
    templateUrl: './export-operators.component.html',
    styleUrls: ['./export-operators.component.scss',
        '../../../../../styles/style-layout.scss']
})

export class ExportOperatorsComponent implements OnInit {
    @Input()
    public visibleExportOperators: boolean = false;

    @Output() changedVisibleExportOperatorsEmit = new EventEmitter<boolean>();
    @Output() sendExportDtoEmit = new EventEmitter<any>();

    protected readonly ExportFileTypeModel = ExportFileTypeModel;

    public exportDto: any = {
        startDate: null,
        endDate: null,
        fileType: null
    };

    constructor() { }

    ngOnInit(): void { }

    public checkExportDtoFields(): boolean {
        return !this.exportDto.startDate || !this.exportDto.endDate || !this.exportDto.fileType;
    }

    clear() {
        this.exportDto = {};
    }

    cancel() {
        this.changedVisibleExportOperatorsEmit.emit(false);
    }

    public clickExport() {
        this.sendExportDtoEmit.emit(this.exportDto);
    }
}
